import './header.css'
import { scroller} from 'react-scroll'

const Header = () => {

    const path = process.env.PUBLIC_URL

    const handleRefresh = () => {
        window.location.reload();
    }

    const handleAboutAutoScroll = () => {
        scroller.scrollTo('about-container', {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        })
    }

    const handleProjectScroll = () => {
        scroller.scrollTo('project-container', {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        })
    }

    return (
        <div className='header-container'>
            <h1 className='brand' onClick={() => handleRefresh()}>Yichi Zhang</h1>
            <nav className='nav-desktop'>
                <ul>
                    <li className='zoom' onClick={() => handleAboutAutoScroll()}>About Me</li>
                    <li className='zoom' onClick={() => handleProjectScroll()}>Projects</li>
                    <li className='zoom'>
                        <a className='nav-link' href="https://www.linkedin.com/in/yichiz5/">Contact</a>
                    </li>
                </ul>

                <button className="zoom resume">
                    <a className='resume-link' href={`${path}/resume.pdf`} >Resume</a>
                </button>
            </nav>

            <nav className='nav-mobile'>
            </nav>
        </div>
    )
}

export default Header;
